const titles = [
  {
    title: "زیست-مواد-دارویی",
    video: `
    <span style={{ display: "block", paddingTop: "57%" }}></span>
    <iframe
      title={matchedTitle.title}
      src="https://www.aparat.com/video/video/embed/videohash/57YSy/vt/frame?recom=none"
      allowFullScreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    ></iframe>
  `,
  },

  {
    title: "اقتصاد-و-مدیریت-دارو",
    video: `
    <span style={{ display: "block", paddingTop: "57%" }}></span>
    <iframe
      title={matchedTitle.title}
      src="https://www.aparat.com/video/video/embed/videohash/AhGXK/vt/frame?recom=none"
      allowFullScreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    ></iframe>
  `,
  },
  {
    title: "شیمی-دارویی",
    video: `
    <span style={{ display: "block", paddingTop: "57%" }}></span>
    <iframe
      title={matchedTitle.title}
      src="https://www.aparat.com/video/video/embed/videohash/1WpCB/vt/frame?recom=none"
      allowFullScreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    ></iframe>
  `,
  },
  {
    title: "فارماکوگنوزی",
    video: `
    <span style={{ display: "block", paddingTop: "57%" }}></span>
    <iframe
      title={matchedTitle.title}
      src="https://www.aparat.com/video/video/embed/videohash/uSqY7/vt/frame?recom=none"
      allowFullScreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    ></iframe>
  `,
  },
  {
    title: "داروسازی-هسته‌ای",
    video: `
    <span style={{ display: "block", paddingTop: "57%" }}></span>
    <iframe
      title={matchedTitle.title}
      src="https://www.aparat.com/video/video/embed/videohash/iqTuc/vt/frame?recom=none" 
      allowFullScreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    ></iframe>
  `,
  },
  {
    title: "کنترل-دارو-و-غذا",
    video: `
    <span style={{ display: "block", paddingTop: "57%" }}></span>
    <iframe
      title={matchedTitle.title}
      src="https://www.aparat.com/video/video/embed/videohash/0DiwI/vt/frame?recom=none"
      allowFullScreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    ></iframe>
  `,
  },
  {
    title: "نانوفناوری-دارویی",
    video: `
    <span style={{ display: "block", paddingTop: "57%" }}></span>
    <iframe
      title={matchedTitle.title}
      src="https://www.aparat.com/video/video/embed/videohash/i5bZV/vt/frame?recom=none"
      allowFullScreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    ></iframe>
  `,
  },
  {
    title: "داروسازی-بالینی",
    video: `
    <span style={{ display: "block", paddingTop: "57%" }}></span>
    <iframe src="https://www.aparat.com/video/video/embed/videohash/RCVr7/vt/frame?recom=none" 
      allowFullScreen="true" 
      webkitallowfullscreen="true" 
      mozallowfullscreen="true">
    </iframe>
  `,
  },
  {
    title: "فارماسیوتیکس",
    video: `
    <span style={{ display: "block", paddingTop: "57%" }}></span>
    <iframe
      title={matchedTitle.title}
      src="https://www.aparat.com/video/video/embed/videohash/9Lxwn/vt/frame?recom=none"
      allowFullScreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    ></iframe>
  `,
  },
  {
    title: "بیوتکنولوژی-دارویی",
    video: `
    <span style={{ display: "block", paddingTop: "57%" }}></span>
    <iframe
      title={matchedTitle.title}
      src="https://www.aparat.com/video/video/embed/videohash/Z056q/vt/frame?recom=none"
      allowFullScreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    ></iframe>
  `,
  },
  {
    title: "سم‌شناسی-و-داروشناسی",
    video: `
    <span style={{ display: "block", paddingTop: "57%" }}></span>
    <iframe
      title={matchedTitle.title}
      src="https://www.aparat.com/video/video/embed/videohash/WLUVw/vt/frame?recom=none"
      allowFullScreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    ></iframe>
  `,
  },
  {
    title: "داروسازی-سنتی",
    video: `
        <span style={{ display: "block", paddingTop: "57%" }}></span>
        <iframe
          title={matchedTitle.title}
          src="https://www.aparat.com/video/video/embed/videohash/7idQv/vt/frame?recom=none"
          allowFullScreen="true"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
        ></iframe>
      `,
  },
];

export default JSON.stringify(titles);
